import { RouteConfig } from 'vue-router';
import { Route } from 'vue-router/types/router';

import Customers from './components/admin/customer/Customers.vue';
import AddCustomer from './components/admin/customer/AddCustomer.vue';
import EditCustomer from './components/admin/customer/EditCustomer.vue';
import ViewCustomer from './components/admin/customer/ViewCustomer.vue';
import Vendors from './components/admin/vendor/Vendors.vue';
import AddVendor from './components/admin/vendor/AddVendor.vue';
import EditVendor from './components/admin/vendor/EditVendor.vue';
import ViewVendor from './components/admin/vendor/ViewVendor.vue';
import Accounts from './components/admin/account/Accounts.vue';
import AddAccount from './components/admin/account/AddAccount.vue';
import EditAccount from './components/admin/account/EditAccount.vue';
import VehicleContracts from './components/admin/contract/vehicle/VehicleContracts.vue';
import AddVehicleContract from './components/admin/contract/vehicle/AddVehicleContract.vue';
import VendorContracts from './components/admin/contract/vendor/VendorContracts.vue';
import CustomerVendorContracts from './components/admin/contract/vendor/CustomerVendorContracts.vue';
import VendorPurchaseInvoices from './components/admin/contract/vendor/VendorPurchaseInvoices.vue';
import EditVehicleContract from './components/admin/contract/vehicle/EditVehicleContract.vue';
import ViewVehicleContract from './components/admin/contract/vehicle/ViewVehicleContract.vue';
import AddVendorContract from './components/admin/contract/vendor/AddVendorContract.vue';
import PurchaseInvoiceRowMappings from './components/admin/vendor/code/PurchaseInvoiceRowMappings.vue';
import AddPurchaseInvoiceRowMapping from './components/admin/vendor/code/AddPurchaseInvoiceRowMapping.vue';
import EditPurchaseInvoiceRowMapping from './components/admin/vendor/code/EditPurchaseInvoiceRowMapping.vue';
import EditVendorContract from './components/admin/contract/vendor/EditVendorContract.vue';
import ViewVendorContract from './components/admin/contract/vendor/ViewVendorContract.vue';
import SalesInvoices from './components/admin/invoice/sales/SalesInvoices.vue';
import RetroactiveSalesInvoices from './components/admin/invoice/sales/RetroactiveSalesInvoices.vue';
import AddSalesInvoice from './components/admin/invoice/sales/AddSalesInvoice.vue';
import AddMonthlySalesInvoice from './components/admin/invoice/sales/AddMonthlySalesInvoice.vue';
import AddNextMonthlySalesInvoice from './components/admin/invoice/sales/AddNextMonthlySalesInvoice.vue';
import EditSalesInvoice from './components/admin/invoice/sales/EditSalesInvoice.vue';
import ViewSalesInvoice from './components/admin/invoice/sales/ViewSalesInvoice.vue';
import AddSalesInvoiceRow from './components/admin/invoice/sales/row/AddSalesInvoiceRow.vue';
import SalesInvoiceRows from './components/admin/invoice/sales/row/SalesInvoiceRows.vue';
import EditSalesInvoiceRow from './components/admin/invoice/sales/row/EditSalesInvoiceRow.vue';
import ViewSalesInvoiceRow from './components/admin/invoice/sales/row/ViewSalesInvoiceRow.vue';
import PurchaseInvoices from './components/admin/invoice/purchase/PurchaseInvoices.vue';
import AddPurchaseInvoice from './components/admin/invoice/purchase/AddPurchaseInvoice.vue';
import EditPurchaseInvoice from './components/admin/invoice/purchase/EditPurchaseInvoice.vue';
import ViewPurchaseInvoice from './components/admin/invoice/purchase/ViewPurchaseInvoice.vue';
import PurchaseInvoiceRows from './components/admin/invoice/purchase/row/PurchaseInvoiceRows.vue';
import AddPurchaseInvoiceRow from './components/admin/invoice/purchase/row/AddPurchaseInvoiceRow.vue';
import EditPurchaseInvoiceRow from './components/admin/invoice/purchase/row/EditPurchaseInvoiceRow.vue';
import ViewPurchaseInvoiceRow from './components/admin/invoice/purchase/row/ViewPurchaseInvoiceRow.vue';
import SplitPurchaseInvoiceRow from './components/admin/invoice/purchase/row/SplitPurchaseInvoiceRow.vue';
import AddOrder from './components/manager/order/AddOrder.vue';
import SmartFleetLoginView from './components/anonymous/SmartFleetLoginView.vue';
import ChangePurchaseInvoiceRowPeriods from './components/admin/invoice/purchase/row/ChangePurchaseInvoiceRowPeriods.vue';
import AddVehicleUsage from './components/user/vehicle/AddVehicleUsage.vue';
import EditVehicleUsage from './components/user/vehicle/EditVehicleUsage.vue';
import UserServices from './components/user/UserServices.vue';
import RegistrationNumberLogin from './components/user/RegistrationNumberLogin.vue';
import ServiceInfo from './components/user/ServiceInfo.vue';
import VendorLocations from './components/admin/vendor-location/VendorLocations.vue';
import AddVendorLocation from './components/admin/vendor-location/AddVendorLocation.vue';
import EditVendorLocation from './components/admin/vendor-location/EditVendorLocation.vue';
import ViewVendorLocation from './components/admin/vendor-location/ViewVendorLocation.vue';
import DistributePurchaseInvoiceRows from './components/admin/invoice/purchase/row/DistributePurchaseInvoiceRows.vue';
import AddVehicleMake from './components/admin/vehicle-make/AddVehicleMake.vue';
import EditVehicleMake from './components/admin/vehicle-make/EditVehicleMake.vue';
import VehicleMakes from './components/admin/vehicle-make/VehicleMakes.vue';
import Dashboard from './components/dashboard/Dashboard.vue';
import Reports from './components/manager/report/Reports.vue';
import FinvoiceParserPatterns from './components/admin/finvoice-parser-pattern/FinvoiceParserPatterns.vue';
import AddFinvoiceParserPattern from './components/admin/finvoice-parser-pattern/AddFinvoiceParserPattern.vue';
import EditFinvoiceParserPattern from './components/admin/finvoice-parser-pattern/EditFinvoiceParserPattern.vue';
import ScheduledTasks from './components/admin/scheduled-task/ScheduledTasks.vue';
import EditDocument from './components/admin/document/EditDocument.vue';
import NetwheelsRequests from './components/admin/netwheels-requests/NetwheelsRequests.vue';
import Budget from './components/admin/balance/Budget.vue';
import VehicleCostMonthlyReports from './components/admin/balance/VehicleCostMonthlyReports.vue';
import SmartFleetTasks from './components/manager/smart-fleet-task/SmartFleetTasks.vue';
import NotificationRecipients from './components/manager/notification-recipient/NotificationRecipients.vue';
import AddNotificationRecipient from './components/manager/notification-recipient/AddNotificationRecipient.vue';
import EditNotificationRecipient from './components/manager/notification-recipient/EditNotificationRecipient.vue';
import EditSmartFleetTask from './components/manager/smart-fleet-task/EditSmartFleetTask.vue';
import AddSmartFleetTask from './components/manager/smart-fleet-task/AddSmartFleetTask.vue';
import ImportVehicleContracts from './components/admin/contract/vehicle/ImportVehicleContracts.vue';
import VehicleContractInspectionDates from './components/admin/contract/vehicle/VehicleContractInspectionDates.vue';
import VehicleContractFillRequestByUser from './components/anonymous/VehicleContractFillRequestByUser.vue';
import VatRates from './components/admin/vat-rate/VatRates.vue';
import EditVatRate from './components/admin/vat-rate/EditVatRate.vue';
import AddVatRate from './components/admin/vat-rate/AddVatRate.vue';

export function getApplicationRoutes(): RouteConfig[] {
    return [
        { path: '/customer', component: Customers },
        { path: '/customer/add', component: AddCustomer },
        { path: '/customer/:id', component: ViewCustomer, props: true },
        { path: '/customer/:id/edit', name: 'EditCustomer', component: EditCustomer, props: true },
        { path: '/customer/:customerId/import-fleet', component: ImportVehicleContracts, props: true },

        { path: '/vendor', component: Vendors },
        { path: '/vendor/add', component: AddVendor },
        { path: '/vendor/:id', component: ViewVendor, props: true },
        { path: '/vendor/:id/edit', name: 'EditVendor', component: EditVendor, props: true },

        { path: '/vendor-location', component: VendorLocations },
        { path: '/vendor-location/add', component: AddVendorLocation },
        { path: '/vendor-location/add/:parentId', component: AddVendorLocation, props: true },
        { path: '/vendor-location/:id', component: ViewVendorLocation, props: true },
        { path: '/vendor-location/:id/edit', component: EditVendorLocation, props: true },

        { path: '/account', component: Accounts },
        { path: '/account/add', component: AddAccount },
        { path: '/account/:id/edit', component: EditAccount, props: true },

        { path: '/vehicle-contract', component: VehicleContracts, name: 'vehicle-contract' },
        { path: '/vehicle-contract/customer/:customerId', component: VehicleContracts, props: true },
        { path: '/vehicle-contract/add', component: AddVehicleContract },
        { path: '/vehicle-contract/inspection-dates', component: VehicleContractInspectionDates, props: true },
        { path: '/vehicle-contract/fill-request', component: VehicleContractFillRequestByUser, props: true },
        { path: '/vehicle-contract/:id', component: ViewVehicleContract, props: true },

        {
            path: '/vehicle-contract/:id/edit',
            name: 'EditVehicleContract',
            component: EditVehicleContract,
            props: true,
        },

        { path: '/vendor-contract', component: VendorContracts },
        { path: '/vendor-contract/add', component: AddVendorContract },
        { path: '/vendor-contract/:id', component: ViewVendorContract, props: true },
        { path: '/vendor-contract/:id/edit', name: 'EditVendorContract', component: EditVendorContract, props: true },

        { path: '/purchase-invoice-row-mapping', component: PurchaseInvoiceRowMappings },
        { path: '/purchase-invoice-row-mapping/add', component: AddPurchaseInvoiceRowMapping },
        { path: '/purchase-invoice-row-mapping/:id/edit', component: EditPurchaseInvoiceRowMapping, props: true },

        { path: '/sales-invoice', component: SalesInvoices },
        { path: '/retroactive-sales-invoice', component: RetroactiveSalesInvoices },
        { path: '/sales-invoice/add', component: AddSalesInvoice },
        { path: '/sales-invoice/add-monthly', component: AddMonthlySalesInvoice },
        { path: '/sales-invoice/add-next-monthly', component: AddNextMonthlySalesInvoice },
        { path: '/sales-invoice/:id', component: ViewSalesInvoice, props: true },
        { path: '/sales-invoice/:id/edit', component: EditSalesInvoice, props: true },
        { path: '/sales-invoice/:salesInvoiceId/add-row', component: AddSalesInvoiceRow, props: true },

        { path: '/sales-invoice-row', component: SalesInvoiceRows },
        { path: '/sales-invoice-row/:id', component: ViewSalesInvoiceRow, props: true },
        { path: '/sales-invoice-row/:id/edit', component: EditSalesInvoiceRow, props: true },

        { path: '/purchase-invoice', component: PurchaseInvoices },
        { path: '/purchase-invoice/add', component: AddPurchaseInvoice },
        { path: '/purchase-invoice/:id', component: ViewPurchaseInvoice, props: true },
        { path: '/purchase-invoice/:id/edit', component: EditPurchaseInvoice, props: true },

        { path: '/purchase-invoice-row', component: PurchaseInvoiceRows },
        { path: '/purchase-invoice/:purchaseInvoiceId/add-row', component: AddPurchaseInvoiceRow, props: true },
        { path: '/purchase-invoice/:id/change-period', component: ChangePurchaseInvoiceRowPeriods, props: true },
        {
            path: '/purchase-invoice/:id/distribute',
            component: DistributePurchaseInvoiceRows,
            props: (route: Route) => ({ purchaseInvoiceRowIds: route.query.purchaseInvoiceRowIds }),
        },
        { path: '/purchase-invoice-row/:id', component: ViewPurchaseInvoiceRow, props: true },
        { path: '/purchase-invoice-row/:id/edit', component: EditPurchaseInvoiceRow, props: true },
        { path: '/purchase-invoice-row/:id/split', component: SplitPurchaseInvoiceRow, props: true },

        { path: '/order/add', component: AddOrder },

        { path: '/company/:customerId/vehicle/:mode', component: VehicleContracts, props: true },
        { path: '/company/:customerId/vendor/:mode', component: VendorContracts, props: true },
        { path: '/company/:customerId/balance/period', component: Budget, props: true },
        { path: '/company/:customerId/reports/costs', component: Reports, props: true },

        {
            path: '/customer-vendor-contract',
            component: CustomerVendorContracts,
            name: 'customer-vendor-contract',
            props: true,
        },

        { path: '/dashboard/:customerId', component: Dashboard, props: true },
        { path: '/dashboard', component: Dashboard },
        { path: '/reports', component: Reports, name: 'reports' },
        {
            path: '/vendor-invoices',
            component: VendorPurchaseInvoices,
            name: 'vendor-invoices',
            props: true,
        },

        { path: '/login', component: SmartFleetLoginView },

        { path: '/budget', component: Budget, name: 'budget' },
        { path: '/vehicle-cost-monthly-report', component: VehicleCostMonthlyReports },

        { path: '/smart-fleet-task', component: SmartFleetTasks },
        { path: '/smart-fleet-task/add', component: AddSmartFleetTask },
        { path: '/smart-fleet-task/:id/edit', component: EditSmartFleetTask, props: true },

        { path: '/vehicle', component: RegistrationNumberLogin },
        { path: '/vehicle/:registrationNumber', component: UserServices, props: true },
        { path: '/vehicle/:registrationNumber/vehicle-usage', component: AddVehicleUsage, props: true },
        { path: '/vehicle/:registrationNumber/vehicle-usage/:id/edit', component: EditVehicleUsage, props: true },
        { path: '/vehicle/:registrationNumber/service-info/:type', component: ServiceInfo, props: true },

        { path: '/vehicle-usage', component: AddVehicleUsage },

        { path: '/finvoice-parser-pattern', component: FinvoiceParserPatterns },
        { path: '/finvoice-parser-pattern/add', component: AddFinvoiceParserPattern },
        { path: '/finvoice-parser-pattern/:id/edit', component: EditFinvoiceParserPattern, props: true },

        { path: '/scheduled-task', component: ScheduledTasks },
        { path: '/netwheels-requests', component: NetwheelsRequests },

        { path: '/file-meta/:id/edit', component: EditDocument, props: true },

        { path: '/vehicle-make', component: VehicleMakes },
        { path: '/vehicle-make/add', component: AddVehicleMake },
        { path: '/vehicle-make/:id/edit', name: 'EditVehicleMake', component: EditVehicleMake, props: true },

        { path: '/notification-recipient', component: NotificationRecipients },
        { path: '/notification-recipient/add', component: AddNotificationRecipient },
        { path: '/notification-recipient/:id/edit', component: EditNotificationRecipient, props: true },

        { path: '/vat-rate', component: VatRates },
        { path: '/vat-rate/add', component: AddVatRate },
        { path: '/vat-rate/:id/edit', component: EditVatRate, props: true },
        // TODO: re-enable this when applicable
        // { path: '/file', component: Files },
        // { path: '/file/add', component: AddFile },
        // { path: '/file/:id', component: ViewFile, props: true },
        // { path: '/file/:id/edit', component: EditFile, props: true },
    ];
}
